import React, { useState } from 'react';
import { Button, Snackbar, Alert } from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { useUpsertFeeScheduleMutation } from '../../../../../services/ContractService';
import { setSelectedFeeSchedule } from '../../../../../services/ContractService/contractSlice';

const SaveFeeScheduleButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const feeSchedule = useAppSelector((state) => state.contract.currentFeeSchedule);
  const [upsertFeeSchedule, { isLoading }] = useUpsertFeeScheduleMutation();
  
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const company = searchParams.get('company') || '';

  const handleSave = async () => {
    if (!feeSchedule) {
      setErrorMessage('No fee schedule selected to save');
      setShowError(true);
      return;
    }

    try {
      console.log('Saving fee schedule:', feeSchedule);
      
      const result = await upsertFeeSchedule({
        feeSchedule: feeSchedule
      }).unwrap();

      console.log('Fee schedule saved successfully:', result);
      
      // Update the Redux state with the saved fee schedule (which may have a new ID if it was created)
      dispatch(setSelectedFeeSchedule(result));
      
      // Show success message
      setShowSuccess(true);
      
      
    } catch (error: any) {
      console.error('Error saving fee schedule:', error);
      
      // Handle different types of errors
      let message = 'Failed to save fee schedule';
      if (error?.data?.message) {
        message = error.data.message;
      } else if (error?.message) {
        message = error.message;
      } else if (typeof error === 'string') {
        message = error;
      }
      
      setErrorMessage(message);
      setShowError(true);
    }
  };

  const handleCloseSuccess = () => {
    setShowSuccess(false);
  };

  const handleCloseError = () => {
    setShowError(false);
    setErrorMessage('');
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<SaveIcon />}
        onClick={handleSave}
        disabled={!feeSchedule || isLoading}
        sx={{ minWidth: 120 }}
      >
        {isLoading ? 'Saving...' : 'Save Fee Schedule'}
      </Button>

      {/* Success Snackbar */}
      <Snackbar
        open={showSuccess}
        autoHideDuration={1500}
        onClose={handleCloseSuccess}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
          Fee schedule saved successfully!
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={handleCloseError}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SaveFeeScheduleButton;
